'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortDescription = undefined;

var _ShortDescription2 = require('./ShortDescription');

var _ShortDescription3 = _interopRequireDefault(_ShortDescription2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ShortDescription = _ShortDescription3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/ShortDescription/index.js
// module id = 1632
// module chunks = 0